import { makeStyles } from "@mui/styles";

import PrimaryButton from "@/components/UI/PrimaryButton/PrimaryButton";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 700,
  },
  image: { height: 280 },
});

export default function ElementIntro(props) {
  const { onCreate, title, image } = props;

  const classes = useStyles();

  return (
    <div className={classes.container} data-testid="element-intro-container">
      <span className={classes.title}>{title}</span>
      <img className={classes.image} src={image} alt="create voice memo element" data-testid="element-intro-image" />
      <PrimaryButton onClick={onCreate} data-analytics="element-modal-next">
        Next
      </PrimaryButton>
    </div>
  );
}
